import axios from 'axios'
import qs from 'qs'

import AuthService from '../services/AuthService'

// Базовый URL и сериализация параметров
export const api = axios.create({
  baseURL: '/api/front/cfg/',
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  paramsSerializer: params => qs.stringify(params, { indices: false, arrayFormat: 'repeat' }),
})

api.interceptors.request.use(config => {
  const token = AuthService.getToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

// Обработка ответа запроса
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        AuthService.doLogin()
      }
      throw error.response
    }

    throw error
  }
)

api.defaults.params = {}

// Добавление параметров по-умолчанию
export const setDefaultsParams = (params: Record<string, string>) => {
  api.defaults.params = {
    ...api.defaults.params,
    ...params,
  }
}

export const setAccessToken = (token: string | null) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`
}
